import React from 'react';
import {Pressable, View} from 'react-native';
import {Divider} from 'react-native-paper';
import {useSelector, useDispatch} from '~/lib/hooks';

import sy from '~/styles';
import {Dialog, Checkbox, Text} from '~/components/controls';
import {setUserSettings} from '~/actions';
import {user as userApi} from '~/api/private';
import PropTypes from 'prop-types';

const MaintenanceExtrasDialog = ({visible, onDismiss, onConfirm}) => {
  const dispatch = useDispatch();
  const user_settings = useSelector((state) => state.user_settings);
  const neverShowAgain = user_settings?.never_show_maintenance_extras_dialog;

  return (
    <Dialog
      title="Extra onderhoud bekijken?"
      onDismiss={onDismiss}
      visible={visible}
      buttons={[
        {
          text: 'Nu niet',
          onPress: onDismiss,
        },
        {
          text: 'OK',
          onPress: async () => {
            if (neverShowAgain) {
              await userApi.update_settings({
                ...user_settings,
                never_show_maintenance_extras_dialog: neverShowAgain,
              });
            }

            onConfirm();
          },
        },
      ]}>
      <View style={[sy['py-4']]}>
        <Text>
          Bekijk de extra services die voor het onderhoud beschikbaar zijn en
          voeg de gewenste items toe.
        </Text>
      </View>
      <Divider style={sy['bg-gray88']} />
      <Pressable
        style={[sy['py-4'], sy['gap-4'], sy['flex-row'], sy['items-center']]}
        onPress={() =>
          dispatch(
            setUserSettings({
              never_show_maintenance_extras_dialog: !neverShowAgain,
            }),
          )
        }>
        <Checkbox checked={neverShowAgain} />
        <Text>Niet meer tonen</Text>
      </Pressable>
    </Dialog>
  );
};
MaintenanceExtrasDialog.propTypes = {
  visible: PropTypes.any,
  onDismiss: PropTypes.any,
  onConfirm: PropTypes.any,
};


export default MaintenanceExtrasDialog;
